import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "regenerator-runtime/runtime.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.from.js";
var NotificationsLinkedTabs = function NotificationsLinkedTabs() {
  return import('@/components/organisms/NotificationsLinkedTabs');
};
var PageTitle = function PageTitle() {
  return import('@/components/molecules/PageTitle');
};
import Nl2br from 'vue-nl2br';
export default {
  components: {
    NotificationsLinkedTabs: NotificationsLinkedTabs,
    PageTitle: PageTitle,
    Nl2br: Nl2br
  },
  data: function data() {
    return {
      artInfos: [],
      arenaInfos: [],
      wpMasters: [],
      accessories: [],
      heroMap: [{
        messageTypes: [6],
        index: 2
      }, {
        messageTypes: [8, 27],
        index: 0
      }],
      heroTypeMap: [{
        messageTypes: [34],
        index: 0
      }],
      extensionMap: [{
        messageTypes: [5],
        index: 2
      }, {
        messageTypes: [7, 14, 15, 16, 17, 23, 24, 25, 26, 30],
        index: 0
      }],
      accessoriesMap: [{
        messageTypes: [102],
        index: 2
      }, {
        messageTypes: [103],
        index: 0
      }],
      userMap: [{
        messageTypes: [5, 6, 28, 102, 201, 203, 326],
        index: 3
      }, {
        messageTypes: [104],
        index: 0
      }, {
        messageTypes: [12],
        index: 1
      }],
      artMap: [{
        messageTypes: [12, 20, 21, 29],
        index: 0
      }, {
        messageTypes: [18, 19],
        index: 1
      }],
      arenaMap: [{
        messageTypes: [36, 37],
        index: 0
      }],
      campaignMap: [{
        messageTypes: [47],
        index: [0, 1]
      }],
      fgMap: [{
        messageTypes: [68, 69, 70, 71]
      }],
      titleMatchMap: [{
        messageTypes: [72, 73, 74, 75, 110]
      }],
      fgBuyHistoryMap: [{
        messageTypes: [76]
      }],
      wccAnticipateMap: [{
        messageTypes: [87, 88, 89, 90, 91, 92]
      }],
      wccFinalReward: [{
        messageTypes: [323, 324]
      }],
      raidMap: [{
        messageTypes: [94, 332, 333]
      }],
      wpMap: [{
        messageTypes: [98]
      }],
      lotteryMap: [{
        messageTypes: [99, 100]
      }],
      allOutWarMap: [{
        messageTypes: [101]
      }],
      giftMap: [{
        messageTypes: [104]
      }],
      dailyRewardMap: [{
        messageTypes: [321]
      }],
      serialCodeMap: [{
        messageTypes: [331]
      }],
      purchaseProcessMap: [{
        messageTypes: [301, 302, 303, 304, 305, 306, 307, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 201, 202, 203, 204, 322, 325, 326, 327, 328, 329, 330, 334]
      }],
      isLoading: true
    };
  },
  computed: {
    getHero: function getHero() {
      return useHeroStore().getHero;
    },
    getHeroType: function getHeroType() {
      return useHeroMaster().getHeroType;
    },
    getExtension: function getExtension() {
      return useExtensionStore().getExtension;
    },
    getType: function getType() {
      return useExtensionMaster().getExtensionType;
    },
    getUser: function getUser() {
      return useUserStore().getUser;
    },
    announcementUnreadCount: function announcementUnreadCount() {
      return useAnnouncementStore().getUnreadCount;
    },
    messages: function messages() {
      return useMessageStore().getMessages;
    },
    readAt: function readAt() {
      return useMessageStore().getReadAt;
    },
    fetchedMessages: function fetchedMessages() {
      var _this = this;
      var messages = this.$util.clone(this.messages);
      return messages.map(function (message) {
        _this.heroMap.forEach(function (m) {
          if (!m.messageTypes.includes(message.type)) return;
          if (!+message.itemsList[m.index]) return;
          var item = _this.getHero(+message.itemsList[m.index]);
          if (!item || !Object.keys(item).length) return;
          message.itemsList[m.index] = "".concat(item.name[_this.$i18n.locale], "#").concat(item.heroId);
        });
        _this.heroTypeMap.forEach(function (m) {
          if (!m.messageTypes.includes(message.type)) return;
          if (!+message.itemsList[m.index]) return;
          var item = _this.getHeroType(+message.itemsList[m.index]);
          if (!item || !Object.keys(item).length) return;
          message.itemsList[m.index] = "".concat(item.rarityStr, ". \"").concat(item.name[_this.$i18n.locale], "\"");
        });
        _this.extensionMap.forEach(function (m) {
          if (!m.messageTypes.includes(message.type)) return;
          if (!+message.itemsList[m.index]) return;
          var item = _this.getExtension(+message.itemsList[m.index]);
          if (!item || !Object.keys(item).length) return;
          message.itemsList[m.index] = "".concat(item.name[_this.$i18n.locale], "#").concat(item.extensionId);
        });
        _this.accessoriesMap.forEach(function (m) {
          if (!m.messageTypes.includes(message.type)) return;
          if (!+message.itemsList[m.index]) return;
          var item = _this.getAccessoryName(+message.itemsList[m.index]);
          if (!item) return;
          message.itemsList[m.index] = "".concat(item);
        });
        _this.userMap.forEach(function (m) {
          if (!m.messageTypes.includes(message.type)) return;
          if (!+message.itemsList[m.index]) return;
          var user = _this.getUser(+message.itemsList[m.index]);
          if (!user.uid) return;
          message.itemsList[m.index] = "".concat(user.name, "#").concat(user.uid);
        });
        _this.artMap.forEach(function (m) {
          if (!m.messageTypes.includes(message.type)) return;
          if (!message.itemsList[m.index]) return;
          var artInfo = _this.artInfos.find(function (art) {
            return art.ipfs === message.itemsList[m.index];
          });
          if (!artInfo) return;
          var item = _this.getHero(artInfo.heroId);
          if (!item || !Object.keys(item).length) return;
          message.itemsList[m.index] = "".concat(item.name[_this.$i18n.locale], "#").concat(item.heroId);
        });
        _this.arenaMap.forEach(function (m) {
          if (!m.messageTypes.includes(message.type)) return;
          if (!message.itemsList[m.index]) return;
          var arenaInfo = _this.arenaInfos.find(function (arena) {
            return Number(arena.arenaId) === Number(message.itemsList[m.index]);
          });
          if (!arenaInfo) return;
          message.itemsList[m.index] = "".concat(arenaInfo.title);
        });
        _this.campaignMap.forEach(function (m) {
          if (!m.messageTypes.includes(message.type)) return;
          if (!message.itemsList[m.index[0]]) return;
          var campaign = useLandMaster().getCampaignData(Number(message.itemsList[m.index[0]]));
          if (!campaign || !Object.keys(campaign).length) return;
          message.itemsList[m.index[0]] = "".concat(campaign.name[_this.$i18n.locale]);
          if (!message.itemsList[m.index[1]]) return;
          var item = useConsumableMaster().getLimitedItem(Number(message.itemsList[m.index[1]]));
          if (!item || !Object.keys(item).length) return;
          message.itemsList[m.index[1]] = "".concat(item.name[_this.$i18n.locale]);
        });
        _this.fgMap.forEach(function (x) {
          if (!x.messageTypes.includes(message.type)) return;
          var fgMaster = {};
          var itemsList = [];
          var str = '';
          var i = 0;
          message.itemsList.forEach(function (item) {
            if (item.indexOf(':') == -1) {
              fgMaster = useQuestMaster().getFgMaster(Number(item));
              if (fgMaster && Object.keys(fgMaster).length) itemsList.push(fgMaster.name[_this.$i18n.locale]);
            } else {
              var parts = item.split(':');
              if (parts.length != 4) return;
              if (Number(parts[0]) == 100) {
                if (i != message.itemsList.length - 1) {
                  str += "#".concat(parts[2], " ").concat(_this.getItem(Number(parts[0]), Number(parts[1]), Number(parts[2])), ", ");
                } else {
                  str += "#".concat(parts[2], " ").concat(_this.getItem(Number(parts[0]), Number(parts[1]), Number(parts[2])), " ");
                }
              } else {
                if (i != message.itemsList.length - 1) {
                  str += "".concat(_this.getItem(Number(parts[0]), Number(parts[1]), 0), " \xD7 ").concat(parts[3], ", ");
                } else {
                  str += "".concat(_this.getItem(Number(parts[0]), Number(parts[1]), 0), " \xD7 ").concat(parts[3], " ");
                }
              }
            }
            i++;
          });
          itemsList.push(str);
          message.itemsList = itemsList;
        });
        _this.fgBuyHistoryMap.forEach(function (x) {
          if (!x.messageTypes.includes(message.type)) return;
          var fgMaster = useQuestMaster().getFgMaster(message.itemsList[0]);
          if (fgMaster && Object.keys(fgMaster).length) message.itemsList[0] = fgMaster.name[_this.$i18n.locale];
        });
        _this.titleMatchMap.forEach(function (x) {
          if (!x.messageTypes.includes(message.type)) return;
          var name = '';
          var itemsList = [];
          var str = '';
          var i = 0;
          message.itemsList.forEach(function (item) {
            if (item.indexOf(':') == -1) {
              name = useTitleMatchMaster().getTitleMatchName(Number(item));
              if (name) itemsList.push(name[_this.$i18n.locale]);
            } else {
              var parts = item.split(':');
              if (parts.length != 4) return;
              if (Number(parts[0]) == 100) {
                if (i != message.itemsList.length - 1) {
                  str += "#".concat(parts[2], " ").concat(_this.getItem(Number(parts[0]), Number(parts[1]), Number(parts[2])), ", ");
                } else {
                  str += "#".concat(parts[2], " ").concat(_this.getItem(Number(parts[0]), Number(parts[1]), Number(parts[2])), " ");
                }
              } else {
                if (i != message.itemsList.length - 1) {
                  str += "".concat(_this.getItem(Number(parts[0]), Number(parts[1]), 0), " \xD7 ").concat(parts[3], ", ");
                } else {
                  str += "".concat(_this.getItem(Number(parts[0]), Number(parts[1]), 0), " \xD7 ").concat(parts[3], " ");
                }
              }
            }
            i++;
          });
          itemsList.push(str);
          message.itemsList = itemsList;
        });
        _this.wccAnticipateMap.forEach(function (m) {
          if (!m.messageTypes.includes(message.type)) return;
          var name = '';
          var itemsList = [];
          var str = '';
          var i = 0;
          message.itemsList.forEach(function (item) {
            var parts = item.split(':');
            if (parts.length != 4) {
              i++;
              return;
            }
            if (Number(parts[0]) == 100) {
              if (i != message.itemsList.length - 1) {
                str += "#".concat(parts[2], " ").concat(_this.getItem(Number(parts[0]), Number(parts[1]), Number(parts[2])), ", ");
              } else {
                str += "#".concat(parts[2], " ").concat(_this.getItem(Number(parts[0]), Number(parts[1]), Number(parts[2])), " ");
              }
            } else if (Number(parts[0]) == 401) {
              if (i != message.itemsList.length - 1) {
                str += "".concat(parts[3], " ").concat(_this.$t('common.zel'), ", ");
              } else {
                str += "".concat(parts[3], " ").concat(_this.$t('common.zel'), " ");
              }
            } else {
              if (i != message.itemsList.length - 1) {
                str += "".concat(_this.getItem(Number(parts[0]), Number(parts[1]), 0), " \xD7 ").concat(parts[3], ", ");
              } else {
                str += "".concat(_this.getItem(Number(parts[0]), Number(parts[1]), 0), " \xD7 ").concat(parts[3], " ");
              }
            }
            i++;
          });
          itemsList.push(str);
          message.itemsList = itemsList;
        });
        _this.wccFinalReward.forEach(function (m) {
          if (!m.messageTypes.includes(message.type)) return;
          var itemsList = [];
          var str = '';
          if (message.type == 324) {
            var i = 0;
            message.itemsList.forEach(function (item) {
              var parts = item.split(':');
              if (parts.length != 4) {
                i++;
                return;
              }
              if (Number(parts[0]) == 100) {
                if (i != message.itemsList.length - 1) {
                  str += "#".concat(parts[2], " ").concat(_this.getItem(Number(parts[0]), Number(parts[1]), Number(parts[2])), ", ");
                } else {
                  str += "#".concat(parts[2], " ").concat(_this.getItem(Number(parts[0]), Number(parts[1]), Number(parts[2])), " ");
                }
              } else if (Number(parts[0]) == 401) {
                if (i != message.itemsList.length - 1) {
                  str += "".concat(parts[3], " ").concat(_this.$t('common.zel'), ", ");
                } else {
                  str += "".concat(parts[3], " ").concat(_this.$t('common.zel'), " ");
                }
              } else {
                if (i != message.itemsList.length - 1) {
                  str += "".concat(_this.getItem(Number(parts[0]), Number(parts[1]), 0), " \xD7 ").concat(parts[3], ", ");
                } else {
                  str += "".concat(_this.getItem(Number(parts[0]), Number(parts[1]), 0), " \xD7 ").concat(parts[3], " ");
                }
              }
              i++;
            });
          } else if (message.type == 323) {
            if (message.itemsList[1]) {
              str += " BPCP \xD7 ".concat(message.itemsList[1], " ");
            }
            if (message.itemsList[2]) {
              str += " ".concat(_this.$t('market.heroes.memoriaTicket'), " \xD7 ").concat(message.itemsList[2], " ");
            }
          }
          itemsList.push(str);
          message.itemsList = itemsList;
        });
        _this.raidMap.forEach(function (m) {
          if (!m.messageTypes.includes(message.type)) return;
          // TOP5ランキング報酬
          if (message.type == 332) {
            return;
          }

          // レイド報酬
          var name = '';
          var itemsList = [];
          var str = '';
          var i = 0;
          var achievements = false;
          message.itemsList.forEach(function (item) {
            var parts = item.split(':');
            if (parts.length != 4) {
              i++;
              return;
            }
            if (Number(parts[0]) == 100) {
              if (i != message.itemsList.length - 1) {
                str += "#".concat(parts[2], " ").concat(_this.getItem(Number(parts[0]), Number(parts[1]), Number(parts[2])), ", ");
              } else {
                str += "#".concat(parts[2], " ").concat(_this.getItem(Number(parts[0]), Number(parts[1]), Number(parts[2])), " ");
              }
            } else if (Number(parts[0]) == 401) {
              if (i != message.itemsList.length - 1) {
                str += "".concat(parts[3], " ").concat(_this.$t('common.zel'), ", ");
              } else {
                str += "".concat(parts[3], " ").concat(_this.$t('common.zel'), " ");
              }
            } else if (Number(parts[0]) == 500) {
              if (!achievements) {
                if (i != message.itemsList.length - 1) {
                  str += "".concat(_this.$t('common.achievements'), ", ");
                } else {
                  str += "".concat(_this.$t('common.achievements'), " ");
                }
                achievements = true;
              }
            } else {
              if (i != message.itemsList.length - 1) {
                str += "".concat(_this.getItem(Number(parts[0]), Number(parts[1]), 0), " \xD7 ").concat(parts[3], ", ");
              } else {
                str += "".concat(_this.getItem(Number(parts[0]), Number(parts[1]), 0), " \xD7 ").concat(parts[3], " ");
              }
            }
            i++;
          });
          itemsList.push(str);
          message.itemsList = itemsList;
        });
        _this.wpMap.forEach(function (m) {
          if (!m.messageTypes.includes(message.type)) return;
          var name = '';
          var itemsList = [];
          var str = '';
          var i = 0;
          var achievements = false;
          var emblem = false;
          message.itemsList.forEach(function (item) {
            if (i < 2) {
              var pushItem = item;
              if (i == 0) {
                pushItem = _this.getWpInfoName(item);
              }
              itemsList.push(pushItem);
            } else {
              var parts = item.split(':');
              if (parts.length != 4) {
                i++;
                return;
              }
              if (Number(parts[0]) == 100) {
                if (i != message.itemsList.length - 1) {
                  str += "#".concat(parts[2], " ").concat(_this.getItem(Number(parts[0]), Number(parts[1]), Number(parts[2])), ", ");
                } else {
                  str += "#".concat(parts[2], " ").concat(_this.getItem(Number(parts[0]), Number(parts[1]), Number(parts[2])), " ");
                }
              } else if (Number(parts[0]) == 401) {
                if (i != message.itemsList.length - 1) {
                  str += "".concat(parts[3], " ").concat(_this.$t('common.zel'), ", ");
                } else {
                  str += "".concat(parts[3], " ").concat(_this.$t('common.zel'), " ");
                }
              } else if (Number(parts[0]) == 500) {
                if (!achievements) {
                  if (i != message.itemsList.length - 1) {
                    str += "".concat(_this.$t('common.achievements'), ", ");
                  } else {
                    str += "".concat(_this.$t('common.achievements'), " ");
                  }
                  achievements = true;
                }
              } else if (Number(parts[0]) == 501) {
                if (!emblem) {
                  if (i != message.itemsList.length - 1) {
                    str += "".concat(_this.$t('users.emblem'), ", ");
                  } else {
                    str += "".concat(_this.$t('users.emblem'), " ");
                  }
                  emblem = true;
                }
              } else {
                if (i != message.itemsList.length - 1) {
                  str += "".concat(_this.getItem(Number(parts[0]), Number(parts[1]), 0), " \xD7 ").concat(parts[3], ", ");
                } else {
                  str += "".concat(_this.getItem(Number(parts[0]), Number(parts[1]), 0), " \xD7 ").concat(parts[3], " ");
                }
              }
            }
            i++;
          });
          itemsList.push(str);
          message.itemsList = itemsList;
        });
        _this.lotteryMap.forEach(function (m) {
          if (!m.messageTypes.includes(message.type)) return;
          var name = '';
          var itemsList = [];
          var str = '';
          var i = 0;
          var achievements = false;
          message.itemsList.forEach(function (item) {
            if (i == 2) {
              var parts = item.split(':');
              if (parts.length != 4) {
                i++;
                return;
              }
              if (Number(parts[0]) == 100) {
                if (i != message.itemsList.length - 1) {
                  str += "#".concat(parts[2], " ").concat(_this.getItem(Number(parts[0]), Number(parts[1]), Number(parts[2])), ", ");
                } else {
                  str += "#".concat(parts[2], " ").concat(_this.getItem(Number(parts[0]), Number(parts[1]), Number(parts[2])), " ");
                }
              } else if (Number(parts[0]) == 401) {
                if (i != message.itemsList.length - 1) {
                  str += "".concat(parts[3], " ").concat(_this.$t('common.zel'), ", ");
                } else {
                  str += "".concat(parts[3], " ").concat(_this.$t('common.zel'), " ");
                }
              } else if (Number(parts[0]) == 500) {
                if (!achievements) {
                  if (i != message.itemsList.length - 1) {
                    str += "".concat(_this.$t('common.achievements'), ", ");
                  } else {
                    str += "".concat(_this.$t('common.achievements'), " ");
                  }
                  achievements = true;
                }
              } else if (Number(parts[0]) == 501) {
                if (!emblem) {
                  if (i != message.itemsList.length - 1) {
                    str += "".concat(_this.$t('users.emblem'), ", ");
                  } else {
                    str += "".concat(_this.$t('users.emblem'), " ");
                  }
                  emblem = true;
                }
              } else {
                if (i != message.itemsList.length - 1) {
                  str += "".concat(_this.getItem(Number(parts[0]), Number(parts[1]), 0), " \xD7 ").concat(parts[3], ", ");
                } else {
                  str += "".concat(_this.getItem(Number(parts[0]), Number(parts[1]), 0), " \xD7 ").concat(parts[3], " ");
                }
              }
            }
            i++;
          });
          itemsList.push(str);
          message.itemsList = itemsList;
        });
        _this.allOutWarMap.forEach(function (m) {
          if (!m.messageTypes.includes(message.type)) return;
          var name = '';
          var itemsList = [];
          var str = '';
          var i = 0;
          var achievements = false;
          var emblem = false;
          message.itemsList.forEach(function (item) {
            if (i > 0) {
              if (i == 1) {
                itemsList.push(item);
              } else {
                var parts = item.split(':');
                if (parts.length != 4) {
                  i++;
                  return;
                }
                if (Number(parts[0]) == 100) {
                  if (i != message.itemsList.length - 1) {
                    str += "#".concat(parts[2], " ").concat(_this.getItem(Number(parts[0]), Number(parts[1]), Number(parts[2])), ", ");
                  } else {
                    str += "#".concat(parts[2], " ").concat(_this.getItem(Number(parts[0]), Number(parts[1]), Number(parts[2])), " ");
                  }
                } else if (Number(parts[0]) == 401) {
                  if (i != message.itemsList.length - 1) {
                    str += "".concat(parts[3], " ").concat(_this.$t('common.zel'), ", ");
                  } else {
                    str += "".concat(parts[3], " ").concat(_this.$t('common.zel'), " ");
                  }
                } else if (Number(parts[0]) == 500) {
                  if (!achievements) {
                    if (i != message.itemsList.length - 1) {
                      str += "".concat(_this.$t('common.achievements'), ", ");
                    } else {
                      str += "".concat(_this.$t('common.achievements'), " ");
                    }
                    achievements = true;
                  }
                } else if (Number(parts[0]) == 501) {
                  if (!emblem) {
                    if (i != message.itemsList.length - 1) {
                      str += "".concat(_this.$t('users.emblem'), ", ");
                    } else {
                      str += "".concat(_this.$t('users.emblem'), " ");
                    }
                    emblem = true;
                  }
                } else {
                  if (i != message.itemsList.length - 1) {
                    str += "".concat(_this.getItem(Number(parts[0]), Number(parts[1]), 0), " \xD7 ").concat(parts[3], ", ");
                  } else {
                    str += "".concat(_this.getItem(Number(parts[0]), Number(parts[1]), 0), " \xD7 ").concat(parts[3], " ");
                  }
                }
              }
            }
            i++;
          });
          itemsList.push(str);
          message.itemsList = itemsList;
        });
        _this.giftMap.forEach(function (x) {
          if (!x.messageTypes.includes(message.type)) return;
          var itemsList = [];
          var str = '';
          var i = 0;
          message.itemsList.forEach(function (item) {
            if (i == 0) {
              itemsList.push(item);
            } else {
              var parts = item.split(':');
              if (parts.length != 4) return;
              if (Number(parts[0]) == 100 || Number(parts[0]) == 300 || Number(parts[0]) == 800) {
                if (i != message.itemsList.length - 1) {
                  str += "#".concat(parts[2], " ").concat(_this.getItem(Number(parts[0]), Number(parts[1]), Number(parts[2])), ", ");
                } else {
                  str += "#".concat(parts[2], " ").concat(_this.getItem(Number(parts[0]), Number(parts[1]), Number(parts[2])), " ");
                }
              } else {
                if (i != message.itemsList.length - 1) {
                  str += "".concat(_this.getItem(Number(parts[0]), Number(parts[1]), 0), " \xD7 ").concat(parts[3], ", ");
                } else {
                  str += "".concat(_this.getItem(Number(parts[0]), Number(parts[1]), 0), " \xD7 ").concat(parts[3], " ");
                }
              }
            }
            i++;
          });
          itemsList.push(str);
          message.itemsList = itemsList;
        });
        _this.purchaseProcessMap.forEach(function (x) {
          if (!x.messageTypes.includes(message.type)) return;

          // アイテム購入成功
          if (message.type == 313) {
            // チケット
            if ([1, 2, 3, 4].includes(Number(message.itemsList[1]))) {
              var ftName = [2, 3, 4].includes(Number(message.itemsList[1])) ? 'BPC' : 'ELS';
              // U召喚チケットの場合は枚数を10倍にする
              var amount = message.itemsList[2];
              if (message.itemsList[1] == 3) amount *= 10;
              message.itemsList[1] = _this.getItem(202, message.itemsList[1] == 1 ? _this.$constants.EXCHANGE_CONSUMEIDS.MemoriaTicket : message.itemsList[1] == 2 ? _this.$constants.EXCHANGE_CONSUMEIDS.MintTicket : message.itemsList[1] == 3 ? _this.$constants.EXCHANGE_CONSUMEIDS.UMintTicket : _this.$constants.EXCHANGE_CONSUMEIDS.LandVolume);
              message.itemsList[1] += _this.$i18n.locale == 'ja' ? "x".concat(amount, " \u679A") : " x".concat(amount);
              message.itemsList[2] = ftName;
            } else if (Number(message.itemsList[1]) < 1000) {
              // ランドセクター
              message.itemsList[1] = useLandMaster().getSectorMaster(Number(message.itemsList[1])).name[_this.$i18n.locale];
              message.itemsList[2] = 'BPC';
            } else {
              // ユニット
              message.itemsList[1] = _this.getItem(300, Number(message.itemsList[1]), {}) + "#".concat(message.itemsList[3]);
              message.itemsList[2] = 'BPC';
            }
          }

          // アイテム購入失敗
          if (message.type == 314) {
            // チケット
            if ([1, 2, 3, 4].includes(Number(message.itemsList[0]))) {
              message.itemsList[0] = _this.getItem(202, Number(message.itemsList[0]) == 1 ? _this.$constants.EXCHANGE_CONSUMEIDS.MemoriaTicket : Number(message.itemsList[0]) == 2 ? _this.$constants.EXCHANGE_CONSUMEIDS.MintTicket : Number(message.itemsList[0]) == 3 ? _this.$constants.EXCHANGE_CONSUMEIDS.UMintTicket : _this.$constants.EXCHANGE_CONSUMEIDS.LandVolume);
              message.itemsList[0] += _this.$i18n.locale == 'ja' ? "x".concat(message.itemsList[1], " \u679A") : " x".concat(message.itemsList[1]);
            } else if (Number(message.itemsList[0]) < 1000) {
              message.itemsList[0] = useLandMaster().getSectorMaster(Number(message.itemsList[0])).name[_this.$i18n.locale];
            } else {
              message.itemsList[0] = _this.getItem(300, Number(message.itemsList[0]), {});
            }
          }

          // Fg履歴売る側
          if (message.type == 307) {
            message.itemsList[1] = useQuestMaster().getFgMaster(Number(message.itemsList[1])).name[_this.$i18n.locale];
          }

          // トレード商品購入買う側
          if ([302, 303, 304, 305, 306, 328].includes(message.type)) {
            var itemType = _this.getItemType(message.type);
            message.itemsList[1] = _this.getItem(itemType, Number(message.itemsList[1]), {
              part: Number(message.itemsList[2]),
              heroType: Number(message.itemsList[3]),
              skillId: Number(message.itemsList[4])
            });
          }

          // トレード商品購入売る側
          if ([308, 309, 310, 311, 312, 201, 203, 326, 329].includes(message.type)) {
            var _itemType = _this.getItemType(message.type);
            message.itemsList[2] = _this.getItem(_itemType, Number(message.itemsList[2]), {
              part: Number(message.itemsList[4]),
              heroType: Number(message.itemsList[5]),
              skillId: Number(message.itemsList[6])
            });
            if (message.type == 203) {
              message.itemsList[2] += ' x' + message.itemsList[4];
            }
          }

          // トレード商品購入失敗
          if ([316, 317, 318, 319, 320, 202, 204, 327, 330].includes(message.type)) {
            var _itemType2 = _this.getItemType(message.type);
            message.itemsList[0] = _this.getItem(_itemType2, Number(message.itemsList[0]), {
              part: Number(message.itemsList[1]),
              heroType: Number(message.itemsList[2]),
              skillId: Number(message.itemsList[3])
            });
          }

          // ユニット購入成功
          if ([322, 325, 334].includes(message.type)) {
            message.itemsList[0] = _this.getItem(300, Number(message.itemsList[0]), {});
          }
        });
        _this.dailyRewardMap.forEach(function (x) {
          if (!x.messageTypes.includes(message.type)) return;
          var itemsList = [];
          var str = '';
          var i = 0;
          message.itemsList.forEach(function (item) {
            if (i == 0) {
              itemsList.push(item);
            } else {
              var parts = item.split(':');
              if (i != message.itemsList.length - 1) {
                str += "".concat(_this.getItem(Number(parts[0]), Number(parts[1]), 0), " \xD7 ").concat(parts[2], ", ");
              } else {
                str += "".concat(_this.getItem(Number(parts[0]), Number(parts[1]), 0), " \xD7 ").concat(parts[2], " ");
              }
            }
            i++;
          });
          itemsList.push(str);
          message.itemsList = itemsList;
        });
        _this.serialCodeMap.forEach(function (x) {
          if (!x.messageTypes.includes(message.type)) return;
          var itemsList = [];
          var str = '';
          var i = 0;
          message.itemsList.forEach(function (item) {
            if (i == 0) {
              var serialCode = useSerialCodeMaster().getSerialCode(Number(item));
              itemsList.push(serialCode === null || serialCode === void 0 ? void 0 : serialCode.name[_this.$i18n.locale]);
            } else {
              var parts = item.split(':');
              var extraObj = {
                part: Number(parts[3]),
                heroType: Number(parts[4]),
                skillId: Number(parts[4])
              };
              if (i != message.itemsList.length - 1) {
                str += "".concat(_this.getItem(Number(parts[0]), Number(parts[1]), extraObj), " \xD7 ").concat(parts[2], ", ");
              } else {
                str += "".concat(_this.getItem(Number(parts[0]), Number(parts[1]), extraObj), " \xD7 ").concat(parts[2], " ");
              }
            }
            i++;
          });
          itemsList.push(str);
          message.itemsList = itemsList;
        });
        return message;
      });
    }
  },
  beforeMount: function beforeMount() {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var wpIds, allIds;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this2.$duelsService.getWinnerPointIds();
          case 2:
            wpIds = _context.sent;
            wpIds.pastWpIdsList.push(wpIds.currentWpId);
            allIds = wpIds.pastWpIdsList;
            _context.next = 7;
            return _this2.$duelsService.getWinnerPointMasters(allIds);
          case 7:
            _this2.wpMasters = _context.sent;
            _context.next = 10;
            return useMessageStore().fetchMessages();
          case 10:
            _context.next = 12;
            return _this2.fetchIpfs();
          case 12:
            if (!_this2.checkUserIds()) {
              _context.next = 15;
              break;
            }
            _context.next = 15;
            return Promise.all([_this2.fetchUsers()]);
          case 15:
            _context.next = 17;
            return Promise.all([_this2.fetchArenaInfo()]);
          case 17:
            if (!_this2.checkExtensionIds()) {
              _context.next = 20;
              break;
            }
            _context.next = 20;
            return Promise.all([_this2.fetchExtensions(_this2.getFetchExtensionIds())]);
          case 20:
            if (!_this2.checkHeroIds()) {
              _context.next = 23;
              break;
            }
            _context.next = 23;
            return Promise.all([_this2.fetchHeroes(_this2.getFetchHeroIds())]);
          case 23:
            if (!_this2.checkAccessoryIds()) {
              _context.next = 27;
              break;
            }
            _context.next = 26;
            return _this2.$accessoryService.getAccessories(_this2.getFetchAccessoryIds());
          case 26:
            _this2.accessories = _context.sent;
          case 27:
            _this2.initSerialCodeMemoriaTypes();
            _this2.isLoading = false;
          case 29:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    fetchHeroes: function fetchHeroes(ids) {
      return useHeroStore().fetchHeroes(ids);
    },
    fetchExtensions: function fetchExtensions(arg) {
      return useExtensionStore().fetchExtensions(arg);
    },
    messageText: function messageText(message) {
      return this.$t("messageTypes.".concat(message.type), message.itemsList).replace(/_\+_/g, ',').replace(/___/g, '"');
    },
    getFetchHeroIds: function getFetchHeroIds() {
      var _concat,
        _ref,
        _this3 = this;
      return (_concat = (_ref = []).concat.apply(_ref, _toConsumableArray(this.heroMap.map(function (h) {
        return _this3.messages.filter(function (message) {
          return h.messageTypes.includes(message.type);
        }).map(function (message) {
          return +message.itemsList[h.index];
        });
      })).concat(_toConsumableArray(this.artInfos.map(function (info) {
        return info.heroId;
      }))))).concat.apply(_concat, _toConsumableArray(this.purchaseProcessMap.map(function (e) {
        return _this3.messages.filter(function (message) {
          return [303, 309, 317, 322, 325, 334].includes(message.type);
        }).map(function (message) {
          return +message.itemsList[message.type == 303 ? 1 : message.type == 309 ? 2 : 0];
        });
      })));
    },
    getFetchExtensionIds: function getFetchExtensionIds() {
      var _concat2,
        _ref2,
        _this4 = this;
      return (_concat2 = (_ref2 = []).concat.apply(_ref2, _toConsumableArray(this.extensionMap.map(function (e) {
        return _this4.messages.filter(function (message) {
          return e.messageTypes.includes(message.type);
        }).map(function (message) {
          return +message.itemsList[e.index];
        });
      })))).concat.apply(_concat2, _toConsumableArray(this.purchaseProcessMap.map(function (e) {
        return _this4.messages.filter(function (message) {
          return [302, 308, 316].includes(message.type);
        }).map(function (message) {
          return +message.itemsList[message.type == 302 ? 1 : message.type == 308 ? 2 : 0];
        });
      })));
    },
    getFetchAccessoryIds: function getFetchAccessoryIds() {
      var _concat3,
        _ref3,
        _this5 = this;
      return (_concat3 = (_ref3 = []).concat.apply(_ref3, _toConsumableArray(this.accessoriesMap.map(function (e) {
        return _this5.messages.filter(function (message) {
          return e.messageTypes.includes(message.type);
        }).map(function (message) {
          return +message.itemsList[e.index];
        });
      })))).concat.apply(_concat3, _toConsumableArray(this.purchaseProcessMap.map(function (e) {
        return _this5.messages.filter(function (message) {
          return [304, 310, 318].includes(message.type);
        }).map(function (message) {
          return +message.itemsList[message.type == 304 ? 1 : message.type == 310 ? 2 : 0];
        });
      })));
    },
    fetchUsers: function fetchUsers() {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _ref4;
        var userIds;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              // ユーザーをフェッチ
              userIds = (_ref4 = []).concat.apply(_ref4, _toConsumableArray(_this6.userMap.map(function (u) {
                return _this6.messages.filter(function (message) {
                  return u.messageTypes.includes(message.type);
                }).map(function (message) {
                  return +message.itemsList[u.index];
                });
              })));
              _context2.next = 3;
              return useUserStore().fetchUsers(userIds);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    fetchIpfs: function fetchIpfs() {
      var _this7 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _ref5;
        var allPromises;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              // アートをフェッチ
              allPromises = _this7.artMap.map(function (a) {
                var artInfoPromises = _this7.messages.filter(function (message) {
                  return a.messageTypes.includes(message.type);
                }).map(function (message) {
                  return _this7.$heroesService.getArtInfo(message.itemsList[a.index]);
                });
                return Promise.all(artInfoPromises);
              });
              _context3.t0 = (_ref5 = []).concat;
              _context3.t1 = _ref5;
              _context3.t2 = _toConsumableArray;
              _context3.next = 6;
              return Promise.all(allPromises);
            case 6:
              _context3.t3 = _context3.sent;
              _context3.t4 = (0, _context3.t2)(_context3.t3);
              _this7.artInfos = _context3.t0.apply.call(_context3.t0, _context3.t1, _context3.t4);
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    fetchArenaInfo: function fetchArenaInfo() {
      var _this8 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _ref6;
        var allPromises, arenas;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              allPromises = _this8.arenaMap.map(function (a) {
                var arenaInfoPromises = _this8.messages.filter(function (message) {
                  return a.messageTypes.includes(message.type);
                }).map(function (message) {
                  return _this8.$arenaService.getArenaInfo(message.itemsList[a.index]).catch(function (e) {});
                });
                return Promise.all(arenaInfoPromises);
              });
              _context4.t0 = (_ref6 = []).concat;
              _context4.t1 = _ref6;
              _context4.t2 = _toConsumableArray;
              _context4.next = 6;
              return Promise.all(allPromises);
            case 6:
              _context4.t3 = _context4.sent;
              _context4.t4 = (0, _context4.t2)(_context4.t3);
              arenas = _context4.t0.apply.call(_context4.t0, _context4.t1, _context4.t4);
              _this8.arenaInfos = arenas.filter(function (arena) {
                return !!arena;
              });
            case 10:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    // シリアルコードメモリア対応
    initSerialCodeMemoriaTypes: function initSerialCodeMemoriaTypes() {
      var messageTypes = this.serialCodeMap.map(function (x) {
        return x.messageTypes;
      }).flat();
      var _iterator = _createForOfIteratorHelper(this.messages),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var message = _step.value;
          if (!messageTypes.includes(message.type)) {
            continue;
          }
          var rewardType = message.itemsList[1].split(':')[0];
          if (rewardType == '301') {
            for (var i = 1; i < message.itemsList.length; i++) {
              var str = '500:';
              var memoriaType = message.itemsList[i].split(':')[1];
              var memoria = useMemoriaMaster().getMemoriaType(Number(memoriaType));
              if (memoria.memoriaPart == 1) {
                str += "".concat(memoriaType, ":").concat(message.itemsList[i].split(':')[2], ":1:").concat(memoria.heroType);
              }
              if (memoria.memoriaPart == 2) {
                str += "".concat(memoriaType, ":").concat(message.itemsList[i].split(':')[2], ":2");
              }
              if (memoria.memoriaPart == 3) {
                str += "".concat(memoriaType, ":").concat(message.itemsList[i].split(':')[2], ":3:").concat(memoria.skillId);
              }
              message.itemsList[i] = str;
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    },
    checkUserIds: function checkUserIds() {
      var _ref7,
        _this9 = this;
      var userIds = (_ref7 = []).concat.apply(_ref7, _toConsumableArray(this.userMap.map(function (u) {
        return _this9.messages.filter(function (message) {
          return u.messageTypes.includes(message.type);
        }).map(function (message) {
          return +message.itemsList[u.index];
        });
      })));
      var userCheck = true;
      for (var i = 0; i < userIds.length; i++) {
        if (isNaN(userIds[i])) {
          userCheck = false;
          break;
        }
      }
      return userCheck;
    },
    checkExtensionIds: function checkExtensionIds() {
      var extensionIds = this.getFetchExtensionIds();
      var extensionCheck = true;
      for (var i = 0; i < extensionIds.length; i++) {
        if (isNaN(extensionIds[i])) {
          extensionCheck = false;
          break;
        }
      }
      return extensionCheck;
    },
    checkHeroIds: function checkHeroIds() {
      var heroIds = this.getFetchHeroIds();
      var heroCheck = true;
      for (var i = 0; i < heroIds.length; i++) {
        if (isNaN(heroIds[i])) {
          heroCheck = false;
          break;
        }
      }
      return heroCheck;
    },
    checkAccessoryIds: function checkAccessoryIds() {
      var accessoryIds = this.getFetchAccessoryIds();
      var check = true;
      for (var i = 0; i < accessoryIds.length; i++) {
        if (isNaN(accessoryIds[i])) {
          check = false;
          break;
        }
      }
      return check;
    },
    getAccessoryName: function getAccessoryName(id) {
      var name = '';
      if (this.accessories.length) {
        var acce = this.accessories.find(function (x) {
          return x.accessoryId == id;
        });
        if (acce) {
          name = this.$i18n.locale == 'ja' ? acce.nameJp : acce.name;
        }
      }
      return name;
    },
    getItem: function getItem(type, itemType, obj) {
      var item = null;
      //- スフィア
      if (type == 100) {
        item = this.getType(itemType);
        if (item) return item.name[this.$i18n.locale];
        //- インゴット
      } else if (type == 200) {
        item = useConsumableMaster().getExpItem(itemType);
        if (item) return item.name[this.$i18n.locale];
        //- 期限つきアイテム
      } else if (type == 201) {
        item = useConsumableMaster().getLimitedItem(itemType);
        if (item) return item.name[this.$i18n.locale];
        //- 消費アイテム
      } else if (type == 202) {
        item = useConsumableMaster().getConsumeItem(itemType);
        if (item) return item.name[this.$i18n.locale];
        //- オーブ
      } else if (type == 203) {
        item = useConsumableMaster().getExtensionExpItem(itemType);
        if (item) return item.name[this.$i18n.locale];
        //- ユニット
      } else if (type == 300) {
        item = this.getHeroType(itemType);
        if (item) return item.name[this.$i18n.locale];
        // アクセサリー
      } else if (type == 400) {
        item = this.getAccessoryName(itemType);
        // メモリア
      } else if (type == 500) {
        // アバターパーツ
        if (obj.part == 1) {
          item = this.getHeroType(obj.heroType);
          if (item) return item.name[this.$i18n.locale] + "#".concat(itemType);
          // ステータスパース
        } else if (obj.part == 2) {
          return {
            ja: 'ステータスパーツ',
            en: 'Status Part'
          }[this.$i18n.locale] + "#".concat(itemType);
          // BBパーツ
        } else if (obj.part == 3) {
          item = useSkillMaster().getSkillById(obj.skillId);
          if (item) return item.name[this.$i18n.locale] + "#".concat(itemType);
        }
        // スフィア ID
      } else if (type == 600) {
        item = this.getExtension(itemType);
        if (item) return item.name[this.$i18n.locale] + "#".concat(itemType);
        // ユニット ID
      } else if (type == 700) {
        item = this.getHero(itemType);
        if (Object.keys(item).length == 0) item = this.getHeroType(itemType);
        if (item) return item.name[this.$i18n.locale] + "#".concat(itemType);
        // ランドセクター
      } else if (type == 800) {
        item = useLandMaster().getSectorMaster(itemType);
        if (item) return item.name[this.$i18n.locale];
      }
      return item;
    },
    getWpInfoName: function getWpInfoName(wpId) {
      var info = this.wpMasters.find(function (w) {
        return w.wpId == wpId;
      });
      if (!info) return '';
      return this.$i18n.locale == 'ja' ? info.nameJp : info.name;
    },
    getItemType: function getItemType(messageType) {
      // スフィア
      if ([302, 308, 316].includes(messageType)) return 600;
      // ユニット
      if ([303, 309, 317].includes(messageType)) return 700;
      // アクセサリー
      if ([304, 310, 318].includes(messageType)) return 400;
      // メモリア
      if ([305, 311, 319, 201, 202].includes(messageType)) return 500;
      // 強化素材
      if ([306, 312, 320, 203, 204].includes(messageType)) return 200;
      // ランドセクター
      if ([326, 327, 328, 329, 330].includes(messageType)) return 800;
    }
  }
};